import config from './config';
import ajax from '../helpers/ajax';
import { getCookie } from '../helpers/utils';

var localeTranscy = getCookie('transcy_basic_locale') || window.Shopify.locale;

const callApi = async function (payload, path, method) {
  let url = config.widget_url + (path || "/v1/widget/product-rating");
  const shopUrl = window.Shopify.shop,
    keyDomain = method === 'get' ? 'shopify_domain' : 'domain';
  let data = {
    [keyDomain]: shopUrl,
    "locale": localeTranscy,
    ...(payload || {})
  };

  try {
    let result = await ajax[method || 'post'](url, data);
    // debugger;
    return result
  } catch (error) {
    console.log(error)
  }
}


export const getRatingCollection = async function ({ product_ids = '' }) {
  // const shopUrl = window.Shopify.shop;
  // var urlSummary = config.shop_url + "/comment/get-summary";
  // if (config.widget_url !== '' && typeof config.widget_url != 'undefined') {
  //   urlSummary = config.widget_url + "/v1/reviews/summary-collection";
  // }
  // let url = config.widget_url + "/v1/widget/product-rating";
  // let data = {
  //   product_ids: product_ids,
  //   shop_domain: shopUrl,
  //   isAdminLogin: true
  // };
  let data = {
    "products": product_ids,
  };

  return callApi(data);
}
export const getRatingProduct = async function (widgetId, productId = '') {
  // var commentUrl = config.shop_url + '/comment/get-review';
  // if (typeof config.widget_url != 'undefined' && config.shop_url !== '') {
  //   commentUrl = config.widget_url + "/v1/reviews/get-reviews";
  // }
  const page = typeof alireviews_page_type != 'undefined' ? alireviews_page_type : null;
  let data = {
    "widgetId": widgetId,
    "products": [productId],
    "page": page,
  };
  // let dataComment = {
  //   'product_id': productId,
  //   'shop_id': shopId,
  //   'num_rand': num_rand,
  //   'isAdminLogin': isAdminLogin,
  //   'star': 'all',
  //   'sort_type': ''
  // }

  return callApi(data);
}

export const getRatingProductDetails = async function (productId = '') {
  let data = {
    "product_id": productId
  };

  return callApi(data, '/v1/widget/product-rating/details', 'get');
}